<template>
  <div class="swiper-content">
    <div  class="swiper-wrapper" ref="swiperWrapper">
      <div class="swiper-item">
        <img class="caseimg" src="../assets/home/case1.png" />
        <div class="content">
          <div class="title">{{$t('home.featured.title1')}}</div>
          <p class="desc">{{$t('home.featured.desc1')}}</p>
          <div class="know-more">
            <div class="more">{{$t('home.featured.know')}}</div>
          </div>
          <div class="case-point">
            <img src="../assets/home/case-point.png" />
          </div>
        </div>

      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/home/case2.png" />
        <div class="content">
          <div class="title">{{$t('home.featured.title2')}}</div>
          <p class="desc">{{$t('home.featured.desc2')}}</p>
          <div class="know-more">
            <div class="more">{{$t('home.featured.know')}}</div>
          </div>
          <div class="case-point">
            <img src="../assets/home/case-point.png" />
          </div>
        </div>
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/home/case3.png" />
        <div class="content">
          <div class="title">{{$t('home.featured.title3')}}</div>
          <p class="desc">{{$t('home.featured.desc3')}}</p>
          <div class="know-more">
            <div class="more">{{$t('home.featured.know')}}</div>
          </div>
          <div class="case-point">
            <img src="../assets/home/case-point.png" />
          </div>
        </div>
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/home/case4.png" />
        <div class="content">
          <div class="title">{{$t('home.featured.title4')}}</div>
          <p class="desc">{{$t('home.featured.desc4')}}</p>
          <div class="know-more">
            <div class="more">{{$t('home.featured.know')}}</div>
          </div>
          <div class="case-point">
            <img src="../assets/home/case-point.png" />
          </div>
        </div>
      </div>
    </div >
    <div class="slide-wrapper">
      <div class="slide">
        <el-progress :percentage="count" color="#E2273E" :show-text="false"></el-progress>
      </div>
      <div class="right-img">
        <img @click="toLeft" class="case-icon" src="../assets/home/case-left.png"/>
        <img @click="toRight" class="case-icon" src="../assets/home/case-right.png"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 1,
      distance: 0,
      count: 33.33
    }
  },
  methods: {
    toRight() {
      if (this.distance == -1154) return
      this.distance = this.distance - 577
      this.count += 33.33
      this.$refs.swiperWrapper.style.transform = `translateX(${this.distance}px)`
    },
    toLeft() {
      if (this.distance == 0) return
      this.distance = this.distance + 577
      this.count -= 33.33
      this.$refs.swiperWrapper.style.transform = `translateX(${this.distance}px)`
    }
  }
}

</script>
<style lang="scss" scoped>
.swiper-content {
  overflow: hidden;
  width: 100%;
}
.swiper-wrapper {
  width: 100%;
  height: 432px;
  display: flex;
  transition: transform 1s;
  .swiper-item {
    display: flex;
    .caseimg {
      width: 313px;
      height: 432px;
    }
    .content {
      position: relative;
      width: 264px;
      height: 432px;
      background: transparent;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;
      box-sizing: border-box;
      .title {
        font-weight: 400;
        color: #424242;
      }
      .desc {
        font-weight: 400;
        font-size: 16px;
        color: #424242;
        text-align: start;
      }
      .know-more {
        width: 100%;
        height: 63px;
        background: url("../assets/home/know-more.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        .more {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 27px;
          color: #FFFFFF;
        }
      }
      .case-point {
        position: absolute;
        left: -35px;
        top: 35px;
        z-index: 9;
        width: 60px;
        height: 60px;
      }
    }
  }
}

.zh {
  .content {
    padding: 0px 40px;
    .title {
      font-size: 43px;
      line-height: 43px;
      margin-top: 73px;
    }
    .desc {
      font-size: 16px;
    }
    .more {
      font-weight: 400;
      font-size: 27px;
    }
  }
}
.en {
  .content {
    padding: 0px 30px;
    .title {
      font-size: 32px;
      line-height: 32px;
      font-weight: bold;
      margin-top: 60px;
    }
    .desc {
      font-size: 16px;
    }
    .more {
      font-weight: 400;
      font-size: 27px;
    }
  }
}

.slide-wrapper {
  padding: 100px 5%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .slide {
    flex: 1;
  }
  .right-img {
    cursor: pointer;
  }
  .case-icon {
    width: 42px;
    height: 42px;
    margin: 0 20px;
  }
}
</style>